import ScrollItem from './ScrollItem';
import './Footer.css';
import FooterLogoWebp from '../img/Footer-logo.webp';
import FooterLogo from '../img/Footer-logo.png';

import {
    BrowserRouter as Router,
    Routes,
    Route,
    Link
} from "react-router-dom";

export default function Footer() {
    return (
        <footer className="Footer">

            <div className="Footer__linkContainer">
                <Link to="/PrivacyPolicy" target="_blank" className="Footer__link">Privacy Policy</Link>
                <Link to="/rule" target="_blank" className="Footer__link">Rules</Link>
                <Link to="/logoguideline" target="_blank" className="Footer__link">Logo Guideline</Link>
            </div>

            <div className="Footer__rightContainer">
                <ScrollItem>
                    <p className="Footer__ltd">721 Genesis Ltd</p>
                </ScrollItem>
                <div className="Footer__logo">
                    <ScrollItem>

                        <picture>
                            <source type="image/webp" srcSet={FooterLogoWebp} />
                            <img src={FooterLogo} alt="BOSO TOKYO logo" />
                        </picture>
                    </ScrollItem>
                </div>
            </div>

        </footer>
    )
}